import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "sticky-header-wrapper mb-14"
};
const _hoisted_2 = {
  key: 0,
  class: "flex flex-col gap-0 w-full"
};
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col gap-0 w-full"
};
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col gap-2"
};
const _hoisted_5 = {
  key: 1,
  class: "w-full h-[28px] flex items-center justify-center text-sm font-semibold text-surface-400"
};
import { ref, computed, watch } from "vue";
import TreeTable from "primevue/treetable";
import Column from "primevue/column";
import OverviewTreeTableHeader from "@/components/overview/logged-time/OverviewTreeTableHeader.vue";
import WeeklyCols from "@/components/overview/logged-time/cols/WeeklyCols.vue";
import DailyCols from "@/components/overview/logged-time/cols/DailyCols.vue";
import MainParentCell from "@/components/overview/logged-time/cell/MainParentCell.vue";
import MainChildCell from "@/components/overview/logged-time/cell/MainChildCell.vue";
import MainTimeTableCell from "@/components/overview/logged-time/cell/MainTimeTableCell.vue";
import ChildTimeTableCell from "@/components/overview/logged-time/cell/ChildTimeTableCell.vue";
import { getDateFromWeek } from "@/composables/useWeeklyDateRange.ts";
import { INTERVAL, DEPTH, OVERVIEW_TABS } from "@/utils/const";
import { useRouter } from "vue-router";
import { useOverviewThresholdSettingStore } from "@/store/pinia/useOverviewThresholdSettingStore";
import { DAY_TYPE } from "@/utils/const";
import network from "@/utils/network";
export default {
  __name: 'OverviewTreeTable',
  setup(__props) {
    const filters = ref({
      query: "",
      loggedTime: [],
      team: [],
      projects: []
    });

    // region Popover settings - Show weekends
    const overviewThresholdSettingStore = useOverviewThresholdSettingStore();
    const showWeekends = computed(() => {
      return overviewThresholdSettingStore.showWeekends;
    });
    // endregion

    const headerLabels = computed(() => {
      return loadedOverviewItems.value[0]?.timeIntervalValues.filter(interval => showWeekends.value ? interval.dayType !== DAY_TYPE.WEEKEND : true).map(interval => interval.id) || [];
    });

    // region Interval
    const router = useRouter();
    const interval = router.currentRoute.value.query.interval;
    const selectedInterval = ref(interval ? interval : INTERVAL.DAILY);
    // endregion

    // region Selected from and to
    const from = router.currentRoute.value.query.from;
    const to = router.currentRoute.value.query.to;
    const selectedFromAndTo = ref({
      from: from ? from : null,
      to: to ? to : null
    });
    const startDate = computed(() => {
      return selectedFromAndTo.value.from;
    });
    const endDate = computed(() => {
      return selectedFromAndTo.value.to;
    });
    // endregion

    // Data
    const axios = network.createAxiosInstance();
    const overviewItems = ref([]);
    const loadedOverviewItems = computed(() => {
      return isLoadingOverview.value ? [] : overviewItems.value;
    });
    const isLoadingOverview = ref(true);
    const overviewError = ref(null);
    const showOverviewSkeleton = ref(false);
    const queryParams = computed(() => {
      const aggregationType = selectedInterval.value === INTERVAL.WEEKLY ? "WEEKLY" : "DAILY";
      const params = new URLSearchParams();
      params.set("aggregationType", aggregationType);
      params.set("startDate", startDate.value);
      params.set("endDate", endDate.value);
      if (filters.value.query) {
        params.set("query", filters.value.query);
      }
      if (filters.value.loggedTime?.length) {
        filters.value.loggedTime.forEach(l => {
          params.append("loggedTime", l);
        });
      }
      if (filters.value.team?.length) {
        filters.value.team.forEach(t => {
          params.append("team", t);
        });
      }
      if (filters.value.projects?.length) {
        filters.value.projects.forEach(p => {
          params.append("project", p);
        });
      }
      const requiredDataTypes = ["ALLOCATION", "WORK_SCHEDULE", "TIME_OFF", "LOGGED"];
      requiredDataTypes.forEach(field => {
        params.append("dataType", field);
      });
      params.set("hierarchyType", "USER_ROOT_PROJECT_CHILD");
      requiredDataTypes.forEach(field => {
        params.append("dataType", field);
      });
      return `?${params.toString()}`;
    });
    const fetchOverview = async () => {
      isLoadingOverview.value = true;
      overviewError.value = null;
      try {
        const response = await axios.get(`/v2/enterprise/time-management/overview/user-project-diff-filtering${queryParams.value}`);
        overviewItems.value = response.data.items || [];
      } catch (err) {
        console.error(err);
      } finally {
        isLoadingOverview.value = false;
        showOverviewSkeleton.value = false;
      }
    };
    watch(() => selectedInterval.value, () => {
      selectedFromAndTo.value.from = null;
      selectedFromAndTo.value.to = null;
    });
    watch(queryParams, () => {
      if (!startDate.value || !endDate.value) {
        return;
      } else {
        fetchOverview();
      }
    }, {
      immediate: true
    });

    // expandedKeys
    const expandedKeys = ref({});
    const isExpanded = key => {
      return Object.keys(expandedKeys?.value).includes(key);
    };

    // Utility functions
    const isNotLastChild = key => {
      if (key.includes(DEPTH.CHILD)) {
        const parent = overviewItems.value.find(item => item.children.some(child => child.key === key));
        return parent.children[parent.children.length - 1].key !== key;
      } else {
        return false;
      }
    };
    const hasProblem = node => {
      return node.children.some(child => child.projectData?.name.includes("projectNotFound"));
    };

    // Exclamation mark calculation
    const headerLabelsBeforeToday = computed(() => {
      if (selectedInterval.value === INTERVAL.WEEKLY) {
        return headerLabels.value.filter(label => {
          const year = label.split("-")[0];
          const week = label.split("-W")[1];
          const endDate = getDateFromWeek(week, year);
          endDate.setDate(endDate.getDate() + 6);
          return endDate < new Date();
        });
      } else {
        return headerLabels.value.filter(label => {
          const endDate = new Date(label);
          endDate.setDate(endDate.getDate()); // + 1 if you want to exclude today
          return endDate < new Date();
        });
      }
    });

    // Url search params - selected interval
    watch(() => [selectedInterval.value, selectedFromAndTo.value], ([newVal, newSelectedFromAndTo]) => {
      const queryParams = new URLSearchParams();

      // Preserve existing query params
      const currentQuery = router.currentRoute.value.query;
      Object.keys(currentQuery).forEach(key => {
        if (key !== "tab" && key !== "interval" && key !== "from" && key !== "to") {
          queryParams.set(key, currentQuery[key]);
        }
      });

      // Set new query params
      queryParams.set("tab", OVERVIEW_TABS.LOGGED_TIME.value);
      queryParams.set("interval", newVal);
      if (newSelectedFromAndTo.from && newSelectedFromAndTo.to) {
        queryParams.set("from", newSelectedFromAndTo.from);
        queryParams.set("to", newSelectedFromAndTo.to);
      }
      router.push({
        query: Object.fromEntries(queryParams)
      });
    });
    return (_ctx, _cache) => {
      const _component_Skeleton = _resolveComponent("Skeleton");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(OverviewTreeTableHeader, {
        class: "border rounded-t-lg px-3.5 py-2 border-surface-100 bg-surface-0",
        "overview-items": overviewItems.value,
        filters: filters.value,
        "onUpdate:filters": _cache[0] || (_cache[0] = $event => filters.value = $event),
        "selected-interval": selectedInterval.value,
        "onUpdate:selectedInterval": _cache[1] || (_cache[1] = $event => selectedInterval.value = $event),
        "selected-from-and-to": selectedFromAndTo.value,
        "onUpdate:selectedFromAndTo": _cache[2] || (_cache[2] = $event => selectedFromAndTo.value = $event)
      }, null, 8, ["overview-items", "filters", "selected-interval", "selected-from-and-to"]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(TreeTable), {
        value: loadedOverviewItems.value,
        scrollable: "",
        expandedKeys: expandedKeys.value,
        "onUpdate:expandedKeys": _cache[3] || (_cache[3] = $event => expandedKeys.value = $event)
      }, {
        empty: _withCtx(() => [isLoadingOverview.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(1, i => {
          return _createVNode(_component_Skeleton, {
            key: i,
            class: "w-full !h-[84px]"
          });
        }), 64)), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(7, i => {
          return _createVNode(_component_Skeleton, {
            key: i,
            class: "w-full !h-[56px]"
          });
        }), 64))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$tf("timeManagementOverview.noData|Nincs adat")), 1))]),
        default: _withCtx(() => [_createVNode(_unref(Column), {
          field: "userId",
          expander: "",
          header: "",
          frozen: "",
          style: {
            "padding": "0 !important"
          },
          class: "!border-r !border-surface-200",
          pt: {
            bodycell: ({
              context
            }) => {
              return {
                class: `z-10 ${isExpanded(context.node.key) || isNotLastChild(context.node.key) ? '!border-b-0' : ''}`
              };
            },
            bodycellContent: '!justify-end !border-b-0 !ml-2',
            headercell: {
              style: 'background-color: var(--p-surface-0) !important;'
            },
            nodetogglebutton: '!rounded-md hover:!bg-surface-100 cursor-pointer',
            nodetoggleicon: '!h-[2rem] !w-[1.5rem] !p-[0.25rem] !text-blue-700 dark:!text-white'
          }
        }, {
          body: _withCtx(({
            node
          }) => [node.key.includes(_unref(DEPTH).ROOT) ? (_openBlock(), _createBlock(MainParentCell, {
            key: 0,
            node: node,
            "has-problem": hasProblem(node)
          }, null, 8, ["node", "has-problem"])) : _createCommentVNode("", true), node.key.includes(_unref(DEPTH).CHILD) ? (_openBlock(), _createBlock(MainChildCell, {
            key: 1,
            node: node,
            "is-last-child": !isNotLastChild(node.key)
          }, null, 8, ["node", "is-last-child"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["pt"]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headerLabels.value, interval => {
          return _openBlock(), _createBlock(_unref(Column), {
            key: interval,
            style: {
              "min-width": "100px",
              "padding": "0 !important"
            },
            pt: {
              bodycell: '!border-b-0'
            }
          }, {
            header: _withCtx(() => [selectedInterval.value === _unref(INTERVAL).WEEKLY ? (_openBlock(), _createBlock(WeeklyCols, {
              key: 0,
              interval: interval,
              "is-loading": isLoadingOverview.value
            }, null, 8, ["interval", "is-loading"])) : _createCommentVNode("", true), selectedInterval.value === _unref(INTERVAL).DAILY ? (_openBlock(), _createBlock(DailyCols, {
              key: 1,
              "overview-items": overviewItems.value,
              interval: interval,
              "is-loading": isLoadingOverview.value
            }, null, 8, ["overview-items", "interval", "is-loading"])) : _createCommentVNode("", true)]),
            body: _withCtx(({
              node
            }) => [node.key.includes(_unref(DEPTH).ROOT) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(MainTimeTableCell, {
              node: node,
              "interval-id": interval,
              field: "workScheduleTime",
              "header-labels-before-today": headerLabelsBeforeToday.value,
              "selected-interval": selectedInterval.value
            }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"]), _createVNode(MainTimeTableCell, {
              node: node,
              "interval-id": interval,
              field: "loggedTime",
              "header-labels-before-today": headerLabelsBeforeToday.value,
              "selected-interval": selectedInterval.value
            }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"]), _createVNode(MainTimeTableCell, {
              node: node,
              "interval-id": interval,
              field: "timeOff",
              "header-labels-before-today": headerLabelsBeforeToday.value,
              "selected-interval": selectedInterval.value
            }, null, 8, ["node", "interval-id", "header-labels-before-today", "selected-interval"])])) : node.key.includes(_unref(DEPTH).CHILD) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(ChildTimeTableCell, {
              "loaded-overview-items": loadedOverviewItems.value,
              node: node,
              "interval-id": interval,
              field: "allocatedTime",
              "header-labels-before-today": headerLabelsBeforeToday.value,
              hasBorderBottom: ""
            }, null, 8, ["loaded-overview-items", "node", "interval-id", "header-labels-before-today"]), _createVNode(ChildTimeTableCell, {
              "loaded-overview-items": loadedOverviewItems.value,
              node: node,
              "interval-id": interval,
              field: "loggedTime",
              "header-labels-before-today": headerLabelsBeforeToday.value,
              hasBorderBottom: ""
            }, null, 8, ["loaded-overview-items", "node", "interval-id", "header-labels-before-today"])])) : _createCommentVNode("", true)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }, 8, ["value", "expandedKeys"])])]);
    };
  }
};